export default "__VITE_ASSET__83ceeba1__"